import { render, staticRenderFns } from "./publishBaseInfo.vue?vue&type=template&id=92fa60e6&scoped=true&"
import script from "./publishBaseInfo.vue?vue&type=script&lang=js&"
export * from "./publishBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./publishBaseInfo.vue?vue&type=style&index=0&id=92fa60e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fa60e6",
  null
  
)

export default component.exports